/* eslint-disable no-use-before-define */
import React from 'react'
import { Fields, getId, Loading, Status, ajax } from '../twd'

export default ({onSelect, onClear, filter, map, showIcon=true, id, dataName='twd-fields-search-cusip', ...props} = {}) => {
    let id_ = id || getId()

    return <React.Fragment>
    <Fields.Search
        id={id_}
        multiple={false}
        showIcon={showIcon}
        onSelect={onSelect}
        onClear={onClear}
        dataName={dataName}
        {...props}
    >{({keyword}) => {
        return <Options dataName={dataName + '-option'} keyword={keyword} filter={filter} map={map} />
    }}</Fields.Search>
    </React.Fragment>
}

const Options = ({keyword, filter, map, dataName='twd-field-search-cusip-option'} = {}) => {
    const { status, error, searchResults } = useOptions({keyword, filter, map})

    return <React.Fragment>
        <Loading status={status} error={error} spinner={false}>
        {
            searchResults.map( (a,i) => (
                <div key={i}
                data-name={dataName}
                className="auto-suggest-menu-item text-truncate"
                style={{ color:"var(--primary-base-color)" }}
                item={a}
                dangerouslySetInnerHTML={{
                    __html: highlightText(a.label, keyword)
                }} />
            ))
        }
        </Loading>
        </React.Fragment>
}

const highlightText = (text, keyword) => {
    let s = (''+keyword).trim()
    return s
        ? text.split(s).join(`<b>${s}</b>`)
        : text

}

const useOptions = ({keyword, filter, map}) => {

    const [status, setStatus] = React.useState(Status.Loading)
    const [error, setError] = React.useState('')
    const [searchResults, setSearchResults] = React.useState([])

    const timerId = React.useRef()
    const lastAbort = React.useRef()
    const lastKeyword = React.useRef()

    React.useEffect(() => {

        if (timerId.current) {
            clearTimeout(timerId.current)
            timerId.current = 0
        }

        var dismounted = false

        timerId.current = setTimeout(async () => {
            if (!keyword) return
            if (lastKeyword.current === keyword && searchResults.length>0) {
                return
            }

            setStatus(Status.LOADING)
            setError('')
            lastKeyword.current = keyword

            try {
                if (lastAbort.current) {
                    lastAbort.current()
                }

                let { data, abort } = await ajax({
                    url: '/esb/portfolio/securitysuggestions',
                    method: 'GET',
                    params: {
                        keyword: keyword.trim(),
                        page:1,
                        start:0,
                        limit:100
                    }
                })

                lastAbort.current = abort
                let a = await data
                if (dismounted) return

                let rs_ = (a.securities || [])
                    .filter(filter)
                    .reduce( (x,a) => {
                        let lv = map(a)
                        let v = lv.value
                        if (!(v in x)) {
                            x[v] = lv.label
                        }
                        return x
                    }, {})
                let rs = Object.keys(rs_).sort()
                    .map(k => ({
                        label:rs_[k],
                        value:k,
                    }))

                if (rs.length===0) throw new Error('empty-result')

                setSearchResults(rs)
                setStatus(Status.LOADED)

            } catch(e) {
                if (dismounted) return

                setSearchResults([])
                setError(`
                    There are no results that match your search for
                    <span class="text-bold"><u>${keyword}</u></span>.
                    Please review your search criteria and try again.
                `)

                setStatus(Status.FAILED_TO_LOAD)
            }
        }, 500)

        return () => {
            dismounted = true
            if (lastAbort.current) {
                lastAbort.current()
                lastAbort.current = null
            }
            if (timerId.current) {
                clearTimeout(timerId.current)
                timerId.current = 0
            }
        }
    }, [keyword])

    return { status, error, searchResults}
}


// WEBPACK FOOTER //
// ./src/twd/fields/search-cusip.js